export default "__VITE_ASSET__DGxemGcy__"